import { cubicBezier, type Variant } from 'framer-motion';

const startEffectAnimationVariant: Variant = {
  opacity: [null, 1, 1, 0],
  transition: {
    duration: 1,
    delay: 1,
    times: [0, 0.3, 0.5, 1],
    ease: [cubicBezier(1, 0, 1, 1), 'linear', cubicBezier(0, 1, 1, 1)],
  },
};

const endEffectAnimationVariant: Variant = {
  opacity: [0, 1, 1, 0],
  transition: {
    duration: 0.8,
    ease: [cubicBezier(0, 0, 0.58, 1), 'linear', 'easeOut'],
    times: [0, 0.375, 0.75, 1],
  },
};

export { endEffectAnimationVariant, startEffectAnimationVariant };
